import { apiClient } from './client';

export interface AuthSettings {
  local_password_enabled: boolean;
  ms_ad_enabled: boolean;
  ms_tenant_id?: string;
  ms_client_id?: string;
  // The secret itself is never returned (#40), only whether one is set.
  ms_client_secret_set?: boolean;
  ms_redirect_uri?: string;
  updated_at: string;
  updated_by?: string;
}

export interface AuthSettingsUpdate {
  local_password_enabled?: boolean;
  ms_ad_enabled?: boolean;
  ms_tenant_id?: string;
  ms_client_id?: string;
  ms_client_secret?: string;
  ms_redirect_uri?: string;
}

export interface MicrosoftConfig {
  ms_tenant_id: string;
  ms_client_id: string;
  // Empty keeps the current secret.
  ms_client_secret: string;
  ms_redirect_uri: string;
}

export const authSettingsApi = {
  // Get public auth settings (no auth required)
  getPublicSettings: async (): Promise<{ local_password_enabled: boolean; ms_ad_enabled: boolean }> => {
    try {
      console.log('Calling API: /auth/settings/auth (public)');
      // Use direct axios instance since this endpoint returns data directly (not wrapped in ApiResponse)
      const response = await apiClient.instance.get<{ local_password_enabled: boolean; ms_ad_enabled: boolean }>('/auth/settings/auth');
      console.log('Public API response:', response.data);
      console.log('Response status:', response.status);
      console.log('Full response:', response);
      
      if (!response.data) {
        throw new Error('Empty response from public auth settings endpoint');
      }
      
      return response.data;
    } catch (error) {
      console.error('API error in getPublicSettings:', error);
      throw error;
    }
  },

  // Get current auth settings (admin only)
  getSettings: async (): Promise<AuthSettings> => {
    try {
      console.log('Calling API: /auth/admin/settings/auth');
      // Use direct axios instance since this endpoint returns data directly (not wrapped in ApiResponse)
      const response = await apiClient.instance.get<AuthSettings>('/auth/admin/settings/auth');
      console.log('API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('API error in getSettings:', error);
      throw error;
    }
  },

  // Update auth settings (admin only)
  updateSettings: async (settings: AuthSettingsUpdate): Promise<AuthSettings> => {
    // Use direct axios instance since this endpoint returns data directly (not wrapped in ApiResponse)
    const response = await apiClient.instance.put<AuthSettings>('/auth/admin/settings/auth', settings);
    return response.data;
  },

  // Update Microsoft configuration (admin only)
  updateMicrosoftConfig: async (config: MicrosoftConfig): Promise<AuthSettings> => {
    // Use direct axios instance since this endpoint returns data directly (not wrapped in ApiResponse)
    const response = await apiClient.instance.put<AuthSettings>('/auth/admin/settings/microsoft', config);
    return response.data;
  }
};